jQuery(document).ready(function($) {

    const notification = '.js-notification';
    const notificationClear = '.js-notification-clear';
    const notificationRemove = '.js-notification-remove';

    const $body = $('body');
    const $moduleNotifications = $('.js-module-notifications');
    const $notificationsContainer = $moduleNotifications.find('.js-notifications-container');
    const $notificationsClose = $moduleNotifications.find('.js-notification-close');
    const $notification = $moduleNotifications.find(notification);
    const $notificationsBell = $('#main-header').find('.js-notifications-bell');
    const $notificationNumber = $notificationsBell.find('.js-notifications-number');

    let notificationNumber = parseInt($notificationNumber.html());



    /*-----------------------------------------------------------------------------------------*/
    /* Modale open / close */
    /*-----------------------------------------------------------------------------------------*/

    closePanelOnScroll();

    $notificationsBell.on('click', function () {
        toggleNotificationsPanel();
    });
    $notificationsClose.on('click', function () {
        toggleNotificationsPanel();
    });


    /*-----------------------------------------------------------------------------------------*/
    /* Handle notifications removal */
    /*-----------------------------------------------------------------------------------------*/

    $notification.on('click', notificationClear, function () {
        const $parent = $(this).closest(notification);
        const notificationId = $parent.data('notification-id');
        setCookie('hidden-notifications['+notificationId+']', notificationId);
    });

    $notification.on('click', notificationRemove, function () {

        $body.addClass('removed-notification');

        $(this).closest(notification).remove();
        notificationNumber = notificationNumber - 1;
        $notificationNumber.html(notificationNumber);

        if ( notificationNumber === 0 ) {
            $body.addClass('no-notifications');
            $notificationsContainer.html(localizedData.noNewNotificationsHtml);
        }

        $body.removeClass('removed-notification');

    });


    /*-----------------------------------------------------------------------------------------*/
    /* Functions */
    /*-----------------------------------------------------------------------------------------*/

    function toggleNotificationsPanel() {
        if ( $body.hasClass('notifications-panel-active') ) {
            closeNotificationsPanel();
        }
        else {
            $body.addClass('notifications-panel-active');
        }
    }

    function closeNotificationsPanel() {
        setCookie('notifications-read', localizedData.dateTime);
        $body.removeClass('notifications-panel-active');
    }

    function closePanelOnScroll() {

        const $document = $(document);
        const $window = $(window);
     
        $window.on( 'scroll', function() {
            panelCloseIfScrolled();
        });
    
        function panelCloseIfScrolled() {		
            const spacer = $document.height() / 6;
            if ( $document.scrollTop() > spacer ) {
                closeNotificationsPanel();
            }
        }
    
    }

});